(()=>{'use strict';const nodes=document.querySelectorAll('[data-reveal]');if(!('IntersectionObserver' in window)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;const observer=new IntersectionObserver(entries=>{for(const e of entries)if(e.isIntersecting){e.target.classList.remove('reveal-pending');e.target.classList.add('reveal-active');observer.unobserve(e.target)}},{threshold:.08,rootMargin:'0px 0px -24px 0px'});nodes.forEach(node=>{if(node.getBoundingClientRect().top>innerHeight){node.classList.add('reveal-pending');observer.observe(node)}});})();

(() => {
  'use strict';
  const dialog = document.querySelector('.ed-image-dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const stage = dialog.querySelector('.ed-image-stage');
  let opener;
  document.querySelectorAll('[data-ed-image]').forEach(link => {
    link.setAttribute('aria-haspopup', 'dialog');
    const hint = link.querySelector('.ed-image-hint');
    hint.firstChild.textContent = link.dataset.zoomLabel + ' ';
    link.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const source = link.querySelector('img');
      const photo = new Image(1254, 1254);
      photo.alt = source.alt;
      photo.src = source.src;
      stage.replaceChildren(photo);
      opener = link;
      dialog.showModal();
      document.documentElement.classList.add('ed-image-open');
    });
  });
  dialog.querySelector('[data-ed-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('ed-image-open');
    opener?.focus({preventScroll:true});
  });
})();
